export default '/pricing/free-offer';
